import { Alert } from '@mantine/core';
import type { FC } from 'react';

import { useI18n } from '../../../../hooks/useI18n.ts';

export const SecretEventAlert: FC = () => {
  const { t } = useI18n();

  return (
    <Alert color="gigi-aqua" p="xs" radius="xs">
      {t('where-and-when_alert--secret') ?? 'You can later make this event known'}
    </Alert>
  );
};
